module.exports = __webpack_public_path__ + "img/hanau-anschlag.bd0fc2fe.png";